import { Modal, Stack, Text, Group, Button, Alert } from '@mantine/core';
import { AlertTriangle } from 'react-feather';
import type { CapacityWarning } from './groups';

interface GroupCapacityWarningModalProps {
  warning: CapacityWarning | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function GroupCapacityWarningModal({
  warning,
  onConfirm,
  onCancel,
}: GroupCapacityWarningModalProps) {
  if (!warning) return null;

  const { targetGroup } = warning;
  const PREFERRED_CAPACITY = 8;

  return (
    <Modal
      opened={!!warning}
      onClose={onCancel}
      title="Group Capacity Warning"
      size="sm"
    >
      <Stack gap="md">
        <Alert
          icon={<AlertTriangle size={16} />}
          color="yellow"
          variant="light"
        >
          <Text size="sm">
            <strong>{targetGroup.name}</strong> is at maximum preferred capacity ({PREFERRED_CAPACITY} participants).
          </Text>
          <Text size="sm" mt="xs">
            Adding this participant will exceed the preferred group size.
          </Text>
        </Alert>

        <Group justify="flex-end" gap="sm">
          <Button variant="default" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="medleyGreen" onClick={onConfirm}>
            Add Anyway
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
